import {
    createSelector,
    createStructuredSelector,
} from 'reselect';
import { initialState } from './reducer';
import { Namespace } from '../../enum';
import { RootState } from '../../interface';
import {
    selectAddress,
    selectAlternativeTariff,
    selectAvailabilityStatus,
    selectAvailableTariffs,
    selectGigakombi,
    selectInitialTariffs,
    selectIsSelectedAvailable,
    selectMarketability,
    selectPreSelectedTariff,
    selectSelectedTariff,
    selectTVProductSelection,
    selectYoung,
} from '../../container/App/selector';

const selectState = (state: RootState) => state[Namespace.AVC] || initialState;

export const selectAvcState = createSelector(selectState, state => state);
export const selectAddresses = createSelector(selectState, state => state.addresses);
export const selectSelectedAddress = createSelector(selectState, state => state.selectedAddress);
export const selectAddressForm = createSelector(selectState, state => state.addressForm);
export const selectError = createSelector(selectState, state => state.error);

export const mapStateToProps = createStructuredSelector({
    addressForm: selectAddressForm,
    addresses: selectAddresses,
    selectedAddress: selectSelectedAddress,
    error: selectError,
    isGigakombi: selectGigakombi,
    isYoung: selectYoung,
    address: selectAddress,
    isTVProductSelected: selectTVProductSelection,
    alternativeTariff: selectAlternativeTariff,
    selectedTariff: selectSelectedTariff,
    isSelectedAvailable: selectIsSelectedAvailable,
    marketability: selectMarketability,
    availableTariffs: selectAvailableTariffs,
    initialTariffs: selectInitialTariffs,
    isAvailabilityChecked: selectAvailabilityStatus,
    preSelectedTariff: selectPreSelectedTariff,
});

/**
 * AVC states by selectors
 */
export type State = ReturnType<typeof mapStateToProps>;
